import { createContext, FC, ReactNode, useMemo, useRef } from 'react'
import { WillowThemeProvider } from '@branch-messenger/willow-ui'
import { WhiteLabelApps } from '@customTypes/white-label'
import { useWhiteLabelAppDetails } from '@src/queries/org'
import { shiftKeyTheme } from '@styles/stitches.config'

type ThemeContextType = { name: string; portalContainer?: HTMLElement | null }

export const ThemeContext = createContext<ThemeContextType>({ name: '' })

interface Props {
  children: ReactNode
}

export const ThemeProvider: FC<Props> = ({ children }) => {
  const { data: appInfo } = useWhiteLabelAppDetails()
  const ref = useRef(null)

  const currentTheme = useMemo(() => {
    if (appInfo?.identifier === WhiteLabelApps.SHIFTKEY)
      return shiftKeyTheme as string
    return ''
  }, [appInfo?.identifier])

  const value = { name: currentTheme, portalContainer: ref.current }

  return (
    <WillowThemeProvider>
      <ThemeContext value={value}>
        <div className={currentTheme} ref={ref}>
          {children}
        </div>
      </ThemeContext>
    </WillowThemeProvider>
  )
}
